import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useLocation } from "react-router-dom";

const Submenu = ({ item }) => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const { pathname } = useLocation();
  return (
    <div>
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex items-center text-primary text-sm font-medium w-full p-2">
              <div className="relative flex items-center w-full">
                <div className="">{item.icon}</div>
                <div className="text-left">{item.title}</div>
              </div>
              <ChevronRightIcon
                className={`${
                  open ? "transform rotate-90" : ""
                } text-gray-500 w-5 h-5 `}
              />
            </Disclosure.Button>
            <Disclosure.Panel className="text-sm px-6 divide-y items-center">
              {item.subNav.map(
                (item, index) =>
                  //Filter sub menu reports per permission
                  userPermissions.includes(item.permission) && (
                    <Link
                      className={
                        item.path === pathname
                          ? "text-secondary flex items-center px-2 font-medium py-2"
                          : "flex items-center px-2 text-gray-500 bg-gray-100 hover:text-primary hover:font-medium py-2"
                      }
                      to={item.path}
                      key={index}
                    >
                      {item.title}
                    </Link>
                  )
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};
export default Submenu;
